//#region Import
import React, { Component } from 'react';
/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { connect } from 'react-redux'

/* Template */
import Nav from '../../template/nav';
import Header from '../../template/header';

/* Routes */
import { AppRoutes } from '../../routes/routes'

import './main.css';
//#endregion

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = { navMini: false }
  }
  
  componentDidMount() {
  }

  componentWillUnmount() {
  }

  toggleNav = (e) => {
    e.preventDefault();
    const _this = this;
    const _state = _this.state
    _this.setState({ navMini: !_state.navMini });
  }

  hideNav = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ navMini: false })
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let navMini = _state.navMini;
    return (
      <div className="app-wrapper">
        <Nav mini={navMini} toggleNav={_this.toggleNav} header navMap />
        <div className={`content-container ${navMini ? 'full' : ''}`}>
          <div className="menu-dropshadow" style={{ display: (navMini ? 'block' : 'none') }} onClick={_this.hideNav}></div>
          <Header {..._props} toggleNav={_this.toggleNav} />
          <AppRoutes {..._props} />
        </div>
      </div>
    )
  }
}

export default connect()(withRouter(Main));